const clauseToAnnotations = clause => {
    const annotations = [];
    for (let index = 0; index < clause.regions.length; index++) {
        const { id, pageNum, coordinates, x1, x2, y1, y2 } = clause.regions[index];
        let coords = {};
        if (coordinates === undefined) {
            coords.x1 = x1;
            coords.x2 = x2;
            coords.y1 = y1;
            coords.y2 = y2;
        }
        else {
            coords = coordinates;
        }
        annotations.push({
            id,
            pageNum,
            coordinates: coords,
        });
    }
    return annotations;
};
const getBookmarkStartPage = bookmark => {
    const firstAnnotation = bookmark.reduce((prev, curr) => {
        return prev.pageNum < curr.pageNum ? prev : curr;
    });
    return firstAnnotation.pageNum;
};
const clausesToBookmarks = clauses => {
    const bookmarks = [];
    clauses.forEach(clause => {
        if (clause.regions.length) {
            const bookmark = {};
            bookmark.annotations = clauseToAnnotations(clause);
            bookmark.startPage = getBookmarkStartPage(bookmark.annotations);
            bookmark.id = clause.id;
            bookmark.name = clause.name || clause.clauseName;
            bookmarks.push(bookmark);
        }
    });
    return bookmarks;
};
export default clausesToBookmarks;
